import * as React from 'react';
import styled from 'styled-components';
import {
  alignItems,
  border,
  borderRadius,
  boxShadow,
  color,
  display,
  height,
  justifyContent,
  maxWidth,
  minWidth,
  space,
  width,
} from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { StyledSystemProps } from '../../theme/StyledSystemProps';

interface MobileLargeButtonProps extends StyledSystemProps {
  id?: string;
  text?: string;
  size?: string;
  color?: string;
  hover?: boolean;
  isIcon?: boolean;
  minimal?: boolean;
  outline?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  style?: object;
  type: 'button' | 'submit' | 'reset';
  isWeb?: boolean;
}

const StyledButton = styled.button`
  ${space};
  ${width};
  ${color};
  ${border};
  ${height};
  ${(props: MobileLargeButtonProps) => (props.hidden ? 'none' : display)};
  ${maxWidth};
  ${alignItems};
  ${borderRadius};
  ${justifyContent};
  ${(props: MobileLargeButtonProps) => !props.isIcon && minWidth};
  ${(props: MobileLargeButtonProps) => !props.minimal && boxShadow};
  cursor: pointer;
  &:hover {
    box-shadow: ${(props: MobileLargeButtonProps) =>
      props.bg === 'transparent' || props.minimal ? 'none' : '0 1px 4px rgba(50,50,93,0.4)'};
    background: ${(props: MobileLargeButtonProps) => props.minimal && 'rgba(50,50,93,0.05)'};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: ${(props: MobileLargeButtonProps) => props.hover && 'translateY(-1px)'};
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.6;
  }

  i,
  i > svg {
    height: ${themeGet('space[2]', '18px')};
    width: ${themeGet('space[2]', '18px')};
  }
  font-size: ${(props: MobileLargeButtonProps) => !props.isWeb && '0.9em'};
  font-weight: ${(props: MobileLargeButtonProps) => !props.isWeb && 600};
  letter-spacing: ${(props: MobileLargeButtonProps) => !props.isWeb && '0.1em'};
`;

const MobileLargeButton: React.FC<MobileLargeButtonProps> = props => {
  return (
    <StyledButton disabled={props.isLoading} {...props}>
      {props.text}
    </StyledButton>
  );
};

MobileLargeButton.defaultProps = {
  alignItems: 'center',
  icon: null,
  size: 'lg',
  bg: 'primary',
  color: '#FFF',
  display: 'flex',
  width: '100%',
  outline: false,
  height: '50px',
  minimal: true,
  text: 'Button',
  isLoading: false,
  p: '0.25em 1.2em',
  minWidth: '150px',
  onClick: () => null,
  borderRadius: '5px',
  justifyContent: 'center',
};

export default MobileLargeButton;
